export default "__VITE_ASSET__Bo6EZn3Y__"